


































































import { Component, Vue, Prop, Ref } from 'vue-property-decorator';
import { FormModel } from 'ant-design-vue';
import moment, {Moment} from 'moment';
import SearchQuotation from '@/components/searchQuotation.vue';
import SelectTeamMember from '@/components/selectTeamMember.vue';
import SelectMemberModal from './selectMemberModal.vue';
import SelectTeamModal from './selectTeamModal.vue';
import { pubsub, CLOSE_TAG_VIEW_EVENT } from '@/utils/pubsub';
import { disabledDate, generateUUID } from '@/utils/other';
import { moduleListInstance } from '@/model/ModuleListClass';
import { templateListInstance } from '@/model/ModuleTemplateListClass';
import { todoListInstance } from '@/model/TodoListClass';
import { generateTemplateOptions } from '@/utils/todo';
import TemplateTodoListModal from './templateTodoListModal.vue';
import { generateLeaderTeams } from '@/utils/team';
import { AccountModule } from '@/store/modules/account';

type IUpdateModuleParams = IModule.IRequest.IUpdateModuleParams;
type ITodoTemplateInfo = IModule.IResponse.ITodoTemplateInfo;
type IUserDetailInfo = IUser.IResponse.IUserDetailInfo;

interface IForm {
  title: string;
  due: Moment | null;
  quotationId: string;
  manDay: number;
  comment: string;
}

interface ITodoTemplateCreateTodoInfo extends ITodoTemplateInfo {
  ownerId: string | null;
  due: Moment | null;
  patternType: 0 | 1 | null;
  teamIds: string[];
}

const titleColumm = {
  slots: { title: 'todoTitle' },
  dataIndex: 'title',
  scopedSlots: { customRender: 'titleInput' },
};
const descriptionColumm = {
  slots: { title: 'descriptionTitle' },
  dataIndex: 'description',
  scopedSlots: { customRender: 'descriptionInput' },
};
const manDayColumn = {
  slots: { title: 'manDayTitle' },
  dataIndex: 'manDay',
  width: '8%',
  align: 'center',
  sorter: (a: ITodoTemplateInfo, b: ITodoTemplateInfo) => a.manDay - b.manDay,
};

@Component({
  components: {
    SearchQuotation,
    TemplateTodoListModal,
    SelectTeamMember,
    SelectMemberModal,
    SelectTeamModal,
  },
})
export default class TemplateCreateModuleForm extends Vue {
  @Ref() private readonly templateTodoListModalRef!: TemplateTodoListModal;
  @Ref() private readonly selectMemberModalRef!: SelectMemberModal;
  @Ref() private readonly selectTeamModalRef!: SelectTeamModal;
  private moduleListInstance = moduleListInstance;
  private templateListInstance = templateListInstance;
  private todoListInstance = todoListInstance;
  private submitLoading: boolean = false;
  private disabledDate = disabledDate;
  private selectedTemplateTodos: ITodoTemplateCreateTodoInfo[] = [];
  private selectedTodos: ITodoTemplateCreateTodoInfo[] = [];
  private form: IForm = {
    title: '',
    quotationId: '',
    due: moment(),
    manDay: 0,
    comment: '',
  };
  private memberOptions: IUserDetailInfo[] = [];
  @Prop({required: true}) private template!: IModule.IResponse.IModuleTemplateInfo;
  @Ref() private readonly moduleForm!: FormModel;
  @Ref() private readonly searchQuotation!: SearchQuotation;
  get formTitle() {
    return this.$t('module.createModule');
  }
  get rules() {
    return {
      title: [{ required: true, message: () => this.$t('form.required'), trigger: 'blur'}],
      due: [{ required: true, message: () => this.$t('form.required'), trigger: 'change'}],
      quotationId: [{ required: true, message: () => this.$t('form.required'), trigger: 'change'}],
      manDay: [{ required: true, message: () => this.$t('form.required'), trigger: 'blur'}],
    };
  }
  get moduleInfo(): IUpdateModuleParams {
    const {moduleTitle, comment}  = this.template;
    return {
      quotationId: '',
      title: moduleTitle,
      due: '',
      manDay: 0,
      comment: comment || '',
    };
  }
  get todos(): ITodoTemplateCreateTodoInfo[] {
    return this.template.templateTodoList.map((todo) => ({
      id: generateUUID(),
      ...todo,
      ownerId: '',
      patternType: 0,
      due: null,
      teamIds: [],
    }));
  }
  get columns() {
    const { typeOption, settlementUnitOption } = generateTemplateOptions(this.selectedTemplateTodos);
    const typeColumn = {
      slots: { title: 'typeTitle' },
      dataIndex: 'typeName',
      width: '10%',
      ellipsis: true,
      filters: typeOption,
      onFilter: (value: string, record: ITodoTemplateInfo) => {
        return record.typeId === value;
      },
    };
    const ownerColumn = {
      slots: { title: 'ownerTitle' },
      dataIndex: 'ownerName',
      scopedSlots: { customRender: 'owner' },
      width: '13%',
    };
    const dueColumn = {
      slots: { title: 'dueTitle' },
      dataIndex: 'due',
      scopedSlots: { customRender: 'due' },
      width: '15%',
    };
    const settlementUnitColumn = {
      dataIndex: 'settlementConfigurationName',
      slots: { title: 'settlementUnitTitle' },
      width: '10%',
      align: 'center',
      filters: settlementUnitOption,
      onFilter: (value: string, record: ITodoTemplateInfo) => record.settlementConfigurationId === value,
    };
    const patternTypeColumn = {
      dataIndex: 'patternType',
      slots: { title: 'patternTypeTitle' },
      scopedSlots: { customRender: 'patternType' },
      width: '8%',
      align: 'center',
    };
    return [
      titleColumm,
      typeColumn,
      manDayColumn,
      settlementUnitColumn,
      dueColumn,
      ownerColumn,
      descriptionColumm,
      patternTypeColumn,
    ];
  }
  get rowSelection() {
    return {
      onChange: (selectedRowKeys: string[], selectedRows: ITodoTemplateCreateTodoInfo[]) => {
        this.selectedTodos = selectedRows;
      },
    };
  }
  private created() {
    this.initFormData();
    generateLeaderTeams(AccountModule.userDetailInfo!.id).then((res) => {
      this.memberOptions = res;
    }).catch((err) => err);
  }
  private initFormData() {
    const {title, quotationId, due, manDay, comment} = this.moduleInfo;
    this.form = {
      title,
      quotationId,
      due: due ? moment(due) : null,
      manDay,
      comment,
    };
    if (quotationId) {
      this.$nextTick(() => {
        this.searchQuotation.searchQuotationById(quotationId);
      });
    }
  }
  private changeSelectedTemplateTodos(todos: ITodoTemplateCreateTodoInfo[]) {
    this.selectedTemplateTodos = this.selectedTemplateTodos.concat(
      todos.map((item) => ({...item, patternType: null, ownerId: null, id: generateUUID()})),
    );
  }
  private changeMember(memberId: string) {
    this.selectedTodos.forEach((todo) => {
      todo.ownerId = memberId;
      todo.patternType = 0;
      todo.teamIds = [];
    });
  }
  private changeTeam(teamIds: string[]) {
    this.selectedTodos.forEach((todo) => {
      todo.ownerId = null;
      todo.patternType = 1;
      todo.teamIds = teamIds;
    });
  }
  private checkManDay() {
    const totalManDay = this.selectedTemplateTodos.reduce((total, todo) => {
      return total + todo.manDay;
    }, 0);
    const manDay = this.form.manDay || 0;
    if (totalManDay > manDay) {
      this.$message.warning(this.$t('template.totalManDayTips').toString());
    }
    return totalManDay <= manDay;
  }
  private checkDue(maxDue: Moment | null) {
    const isAllHasDue = this.selectedTemplateTodos.every((todo) => todo.due);
    if (!isAllHasDue) {
      this.$message.warning(this.$t('template.dueTips').toString());
      return false;
    }
    const isMoreThanDue = maxDue ? this.selectedTemplateTodos.some((todo) => {
      return maxDue.isSameOrAfter(todo.due!.format('YYYY-MM-DD'), 'date');
    }) : true;
    if (!isMoreThanDue) {
      this.$message.warning(this.$t('template.moreThanDueTips').toString());
      return false;
    }
    return true;
  }
  private checkOwner() {
    const res = this.selectedTemplateTodos.every((todo) => todo.ownerId || todo.patternType === 1);
    if (!res) {
      this.$message.warning(this.$t('template.unBoundOwner').toString());
    }
    return res;
  }
  private checkComment() {
    const res = this.selectedTemplateTodos.every((todo) => {
      if (todo.patternType === 1) {
        return Boolean(todo.description);
      }
      return true;
    });
    if (!res) {
      this.$message.warning(this.$t('template.commentTips').toString());
    }
    return res;
  }
  private dueDisabledDate(current: Moment) {
    let endDate = moment().endOf('year');
    const startDate = moment().startOf('day');
    if (this.form.due) {
      endDate = moment(this.form.due).endOf('day');
    }
    return current && (current < startDate || current > endDate);
  }
  private handleSubmit() {
    this.moduleForm.validate((valid) => {
      const todoLengthEqual0 = this.selectedTemplateTodos.length === 0;
      const manDayIsOK = todoLengthEqual0 || this.checkManDay();
      // const dueIsOK = todoLengthEqual0 || this.checkDue(this.form.due);
      // const ownerIOK = todoLengthEqual0 || this.checkOwner();
      const commentOK = todoLengthEqual0 || this.checkComment();
      if (valid && manDayIsOK && commentOK) {
        const {title, due, quotationId, manDay, comment} = this.form;
        const dueValue = due ? due.format('YYYY-MM-DD') : '';
        const updateInfo: IUpdateModuleParams = {
          title,
          quotationId,
          due: dueValue,
          manDay,
          comment,
        };
        this.submitModule(updateInfo);
      } else {
        return false;
      }
    });
  }
  private submitModule(updateInfo: IUpdateModuleParams) {
    this.submitLoading = true;
    this.createModule(updateInfo).then((res) => {
      this.$message.success(res);
    }).catch((err) => {
      this.$message.warning(err);
    }).finally(() => {
      this.submitLoading = false;
    });
  }
  private updateQuotation(quotation: ISolution.IResponse.ISolutionInfo | null) {
    if (quotation) {
      if (quotation.projectId === this.template.projectId) {
        this.form.quotationId = quotation.id;
        this.form.title = quotation.title;
      } else {
        this.$message.warning(this.$t('template.projectTips').toString());
        this.form.quotationId = '';
      }
    } else {
      this.form.quotationId = '';
    }
  }
  private goListPage() {
    pubsub.publish(CLOSE_TAG_VIEW_EVENT, this.$route.path);
    this.$router.push({
      name: 'Module',
    });
  }
  private createModule(module: IModule.IRequest.IUpdateModuleParams): Promise<string> {
    return new Promise((reslove, reject) => {
      this.moduleListInstance.requestCreateModuleFromTemplate(module).then((res) => {
        reslove(res.msg);
        this.batchCreateTodo(res.id);
      }).catch((err) => {
        reject(err);
      });
    });
  }
  private batchCreateTodo(moduleId: string) {
    if (!this.templateListInstance.moduleTemplate) {
      this.unshiftModule(moduleId);
      return;
    }
    if (this.selectedTemplateTodos.length < 1) {
      this.unshiftModule(moduleId);
      return;
    }
    const allTodoList: ITodo.IRequest.IBatchCreateTodoParams[] = this.selectedTemplateTodos.map((todoTemplate) => {
      const {id, typeId, typeName, manDay, title, description, settlementConfigurationId,
        patternType, ownerId, due, teamIds} = todoTemplate;
      return {
        id,
        moduleId,
        typeId,
        typeName,
        isBonus: false,
        manDay,
        title,
        description,
        owner: patternType === 1 ? null : ownerId,
        due: due ? due.format('YYYY-MM-DD') : null,
        settlementConfigurationId,
        comment: '',
        patternType: (patternType === 1 || patternType === 0) ? patternType : null,
        teamIds,
      };
    });
    this.todoListInstance.requestBatchCreateTodo(allTodoList).then((res) => {
      // this.$message.success(res);
    }).catch((err) => {
      this.$message.warning(err);
    }).finally(() => {
      this.unshiftModule(moduleId);
    });
  }
  private unshiftModule(moduleId: string) {
    this.moduleListInstance.requestDataForUnshift(moduleId).finally(() => {
      this.goListPage();
    });
  }
  private showTemplateTodoListModal() {
    this.templateTodoListModalRef.showModal();
  }
  private showSelectMemberModal() {
    this.selectMemberModalRef.showModal();
  }
  private showSelectTeamModal() {
    this.selectTeamModalRef.showModal();
  }
  private changeTodopatternType(memberId: string, todo: ITodoTemplateCreateTodoInfo) {
    if (memberId) {
      todo.patternType = 0;
      todo.teamIds = [];
    }
  }
  private removeTodo() {
    const selectedTodoIds = this.selectedTodos.map((todo) => todo.id);
    this.selectedTemplateTodos = this.selectedTemplateTodos.filter((todo) => !selectedTodoIds.includes(todo.id));
    this.selectedTodos = [];
  }
}
